import { render, staticRenderFns } from "./CardexForm.vue?vue&type=template&id=1706a3d3&scoped=true&"
import script from "./CardexForm.vue?vue&type=script&lang=js&"
export * from "./CardexForm.vue?vue&type=script&lang=js&"
import style0 from "./CardexForm.vue?vue&type=style&index=0&id=1706a3d3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1706a3d3",
  null
  
)

export default component.exports
import {QScrollArea,QInput} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QScrollArea,QInput})
